// Expense Reports API
import apiClient from '@/core/lib/api-client';

export interface TaxReport {
  id: string;
  year: number;
  totalDeductible: number;
  categories: Record<string, number>;
  generatedAt: string;
}

export interface ExpenseReport {
  id: string;
  name: string;
  dateRange: { start: string; end: string };
  totalAmount: number;
  expenses: any[];
}

export const reportsApi = {
  getTaxReport: async (familyId: string, year: number): Promise<TaxReport> => {
    const response = await apiClient.get('/expenses/reports/tax', {
      params: { familyId, year },
    });
    return response.data;
  },

  generateTaxReport: async (familyId: string, year: number): Promise<TaxReport> => {
    const response = await apiClient.post('/expenses/reports/tax', {
      familyId,
      year,
    });
    return response.data;
  },

  getExpenseReport: async (familyId: string, params: any): Promise<ExpenseReport> => {
    const response = await apiClient.get('/expenses/reports', {
      params: { familyId, ...params },
    });
    return response.data;
  },

  exportReport: async (familyId: string, format: 'pdf' | 'csv'): Promise<Blob> => {
    const response = await apiClient.get('/expenses/reports/export', {
      params: { familyId, format },
      responseType: 'blob',
    });
    return response.data;
  },
};

export default reportsApi;
